import { Component, Input, Output, EventEmitter, Signal, WritableSignal } from '@angular/core';
import { Router } from "@angular/router";
import { MatDialog } from '@angular/material/dialog';
import { IDisbursementSession } from 'src/app/interfaces/disbursement-session';
import { IFundingAccount } from 'src/app/interfaces/funding-account';
import { FundingAccountsService } from 'src/app/services/funding-accounts.service';
import { SharedService } from 'src/app/services/shared.service';
import { ConfirmationDialogComponent } from '../../components/confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'app-funding-account',
  templateUrl: './funding-account.component.html',
  styleUrls: ['./funding-account.component.css']
})
export class FundingAccountComponent {

  @Input() fundingAccount!: IFundingAccount;
  @Input() dsbOccurrenceUuid!: string;
  @Output() deleteFundingAccount: EventEmitter<string> = new EventEmitter<string>();

  // @Input({ required: true }) varTest!: Signal<string>;
  @Input({ required: true }) varTest!: WritableSignal<string>;

  envRegion!: string;
  disbursementSession!: IDisbursementSession;

  public constructor(
    private router: Router,
    private dialog: MatDialog,
    private fundingAccountsService: FundingAccountsService,
    private sharedService: SharedService) {
  }

  isBank(): boolean {
    let fundingSubtype = this.fundingAccount.fundingSubtype || null;
    return fundingSubtype != null && (fundingSubtype.includes('CHECKING') || fundingSubtype.includes('SAVINGS'));
  }

  isCard(): boolean {
    let fundingSubtype = this.fundingAccount.fundingSubtype || null;
     return fundingSubtype != null && (fundingSubtype.includes('VISA')
            || fundingSubtype.includes('MC') || fundingSubtype.includes('AMEX')
            || fundingSubtype.includes('DISC') || fundingSubtype.includes('DEBIT'));
  }


  resetVarTest(): void {
    this.varTest.set(Date.now().toString());
  }

  get fundingAccountDescription(): string {
    if(this.fundingAccount.institutionName) {
      return this.fundingAccount.institutionName;
    } else if(this.isCard()) {
      return 'Card ' + this.fundingAccount.maskedFundingAccount;
    } else if(this.isBank()) {
      return 'Bank account ' + this.fundingAccount.maskedFundingAccount;
    } else {
      return this.fundingAccount.fundingSubtype;
    }
  }

  ngOnInit() {
    // Get the current enviromental region
    this.envRegion = this.sharedService.getEnvRegion();

    // Get the current disbursement session
    this.disbursementSession = this.sharedService.getDisbursementSession();
  }

  onEditFundingAccount(fundingAccount: IFundingAccount) {
    let tokenId = fundingAccount.tokenid;
    console.log('calling onEditFundingAccount', tokenId, this.dsbOccurrenceUuid );
    console.log(this.envRegion, this.disbursementSession.sessionId);
  }

  onChooseFundingAccount(tokenId: string) {
    console.log('calling onChooseFundingAccount', tokenId, this.dsbOccurrenceUuid );
    console.log(this.envRegion, this.disbursementSession.sessionId);
    if (tokenId) {
      // Emit the chosen funding account back to disbursement occurrences page
      // this.FundingAccountChosen.emit(this.fundingAccounts.find(element => element.tokenid == tokenId));
      // let fundingAccount: any = this.fundingAccounts.find(element => element.tokenid == tokenId);
      // let navigationExtras: NavigationExtras = {
      //   state: {
      //     fundingAccount: fundingAccount
      //   },
      // };
      // this.router.navigate(["/dsb-ocr"], navigationExtras);
      this.fundingAccountsService.linkFundingAccountToOccurrence(this.envRegion, this.disbursementSession.sessionId,
        tokenId, this.dsbOccurrenceUuid)
      .subscribe(
        (response) => {
          console.log('response:', response);
          if (response) {
            console.log('Navigating to /dsb-ocr');
            this.router.navigate(["/dsb-ocr"]);
          }
/*
from Ark Furmansky (internal) to Everyone:    9:44  AM
    this.disbursementCustomerService.postDisbursementInvitation(brandCode, dsbInviteRequest)
    .subscribe({
      next: (response) => {
          this.isDsbMessageShown = true;
          this.dsbMessage = `Disbursement invitation has been successfully processed. Reference #: ${response.disbursementOccurrenceUuid}`;
      },
      error: (e) => {
          this.isDsbMessageShown = true;
          this.dsbMessage = e; //'Unable to post a disbursement invitation';
      },
      complete: () => {
      }
  });

*/

        // },
        // (error) => {
        //   console.log('error:', error);
        }
      )
    }
  }

  onDeleteFundingAccount(tokenId: string) {
    console.log('calling onDeleteFundingAccount' );
    let message = this.sharedService.getCustomizedPrompt("FUNDING_ACCOUNT_CONFIRM_DELETE") 
      || "Do you really want to delete the funding account {fundingAccount}? You will no longer be able to use this funding account for future transactions.?";
    message = message.replace('{fundingAccount}', 
      this.fundingAccount?.maskedFundingAccount || this.fundingAccount.fundingAccountNickname || '');   
    const dialogRef = this.dialog.open(ConfirmationDialogComponent,{
      data:{
        title: 'Delete Funding Account', // this.sharedService.getCustomizedTitle('APP_TITLE'),
        message: message,
        buttonText: {
          ok: 'Yes',
          cancel: 'No'
        }
      }
    });

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.fundingAccountsService.deleteFundingAccount(this.envRegion, this.disbursementSession.sessionId, tokenId)
        .subscribe({
          next: (response) => {
            if (response) {
              this.deleteFundingAccount.emit(response.status);
            }
          },
          error: (error) => {
          },
          complete: () => {
          }
        });
      }
    });
  }
}
